import { Params } from "../interface/core.interface";
import {
  ICheckoutPayload,
  IRePaymentPayload,
} from "../interface/order.interface";
import { OrderMaster } from "../interface/order-master.interface";

export class GetOrdersAction {
  static readonly type = "[Order] Get";
  constructor(public payload?: Params) {}
}

export class ViewOrderAction {
  static readonly type = "[Order] View";
  constructor(public id: number) {}
}

export class CheckoutAction {
  static readonly type = "[Order] Checkout";
  constructor(public payload: ICheckoutPayload) {}
}

export class GetOrderDetailsAction {
  static readonly type = "[Order] Get Details";
  constructor(public payload: string) {}
}
export class PlaceOrderAction {
  static readonly type = "[Order] Place";
  constructor(public payload: ICheckoutPayload) {}
}

export class CreateOrderAction {
  static readonly type = "[Order] Create";
  constructor(public payload: OrderMaster) {}
}

export class SaaScreateOrderAction {
  static readonly type = "[Order] SaaS Create";
  constructor(public payload: OrderMaster) {}
}

export class UpdateOrderAddressAction {
  static readonly type = "[Order] Update Address";
  constructor(
    public id: number,
    public payload: OrderMaster
  ) {}
}

export class ClearAction {
  static readonly type = "[Order] Clear";
  constructor() {}
}

export class RePaymentAction {
  static readonly type = "[Order] Repayment";
  constructor(public payload: IRePaymentPayload) {}
}

export class VerifyPaymentAction {
  static readonly type = "[Order] Verify";
  constructor(public id: number) {}
}
